import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-scora-dropdown-ui',
  templateUrl: './scora-dropdown-ui.component.html',
  styleUrls: ['./scora-dropdown-ui.component.scss']
})
export class ScoraDropdownUiComponent implements OnInit {

  @Input() dropDown: any;
  @Output() selectedOptionValue = new EventEmitter<any>();
  @Output() toggle = new EventEmitter<any>();
  show_option: boolean;
  search: string = '';
  filteredItems: any[] = [];
  dropdowns: { id: string, isVisible: boolean }[] = [];
  constructor(private sanitizer: DomSanitizer) {
   
   }
   ngOnInit() {
     if(this.dropDown){
       this.dropdowns.push({ id: this.dropDown.id, isVisible: false });
     }
     // tag-dailog
   }
 
   handleOptionChange(selectedItem: any): void {
     if(this.dropDown.isSingle){
       const index = this.dropDown.selectedData.findIndex(item => item.id === selectedItem.id);
       if (index === -1) {
         this.dropDown.selectedData =[]
         // Item not found, add it to selectedItems
         this.dropDown.selectedData.push(selectedItem);
       } else {
         // Item found, remove it from selectedItems
         this.dropDown.selectedData.splice(index, 1);
       }
     }else{
       const index = this.dropDown.selectedData.findIndex(item => item.id === selectedItem.id);
       if (index === -1) {
         // Item not found, add it to selectedItems
         this.dropDown.selectedData.push(selectedItem);
       } else {
         // Item found, remove it from selectedItems
         this.dropDown.selectedData.splice(index, 1);
       }
     }
     this.selectedOptionValue.emit(this.dropDown.selectedData);
 
   }
 
   showOption(dropDownId: string) {
     this.filteredItems = this.dropDown.items;
     this.dropDown.isOption = !this.dropDown.isOption;
     this.toggle.emit(this.dropDown)
     this.filterItems()
   }
 
 
 
   dropdownIsActive(dropDownId: string): boolean {
     const dropdown = this.dropdowns.find(d => d.id === dropDownId);
     return dropdown ? dropdown.isVisible : false;
   }
 
   filterItems(): void {
     if (!this.search) {
       this.filteredItems = this.dropDown.items.map(item => ({
         ...item,
         itemNames: item.items_count != undefined ? this.sanitizer.bypassSecurityTrustHtml(`${item.itemName} <span class="numb" style="color:#1BBC9B;">(${item.items_count})</span>`) : this.sanitizer.bypassSecurityTrustHtml(`${item.itemName}`)
     }));
     } else {
       this.filteredItems = this.dropDown.items.filter((item:any) => {
         const matched = item.itemName.toLowerCase().startsWith(this.search.toLowerCase());
         if (matched) {
           item.itemNames = this.highlightMatch(item.itemName, item.items_count);
         }
         return matched;
       });
     }
   }
 
 
   highlightMatch(itemName: string ,items_count:string): SafeHtml {
     if (!this.search) {
       return items_count != undefined ? this.sanitizer.bypassSecurityTrustHtml(`${itemName}`) : this.sanitizer.bypassSecurityTrustHtml(`${itemName} <span class="numb" style="color:#1BBC9B;">(${items_count})</span>`);
     }
     const index = itemName.toLowerCase().indexOf(this.search.toLowerCase());
     if (index !== -1) {
       const matched = itemName.substr(index, this.search.length);
       const beforeMatch = itemName.substr(0, index);
       const afterMatch = itemName.substr(index + this.search.length);
       const highlightedText = items_count != undefined ? this.sanitizer.bypassSecurityTrustHtml(`${beforeMatch}<span class="highlight" style="color:black; background-color: white;">${matched}</span>${afterMatch} <span class="numb" style="color:#1BBC9B;">(${items_count})</span>`) : this.sanitizer.bypassSecurityTrustHtml(`${beforeMatch}<span class="highlight" style="color:black; background-color: white;">${matched}</span>${afterMatch}`)
       return highlightedText;
     }
     return this.sanitizer.bypassSecurityTrustHtml(itemName);
   }
 
 
   selectAll() {
     
     if(this.dropDown.selectedData.length == this.filteredItems.length){
       this.dropDown.selectedData =[]
     }else{
       this.dropDown.selectedData = this.filteredItems;
     }
  
    this.selectedOptionValue.emit(this.dropDown.selectedData);
 
   }
   isSelected(item: any): boolean {
     return this.dropDown.selectedData.some(selectedItem => selectedItem.id === item.id);
   }
   isSelectedAll(): boolean {
     return this.filteredItems.length == this.dropDown.selectedData.length ? true : false
   }
   removeItem(selectedItem){
     const index = this.dropDown.selectedData.findIndex(item => item.id === selectedItem.id);
     if (index === -1) {
       // Item not found, add it to selectedItems
       // this.dropDown.selectedData.push(selectedItem);
     } else {
       // Item found, remove it from selectedItems
       this.dropDown.selectedData.splice(index, 1);
     }
     
     this.selectedOptionValue.emit(this.dropDown.selectedData);
   }
 
   tagOpen() {
     $('#tag-dailog').modal('show');
   }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-dropdown-ui/scora-dropdown-ui.component.ts